<div class="top-container w-100 h-100">
  <ng-container *ngIf="offer != null">

    <span (click)="offerChange.emit(null)" class="back-arrow back d-flex gap-1 mt-2 mb-5 marg cursor-pointer">
      <img alt="" src="" class="me-2">
      {{'offer.backToOverview' |translate}}
    </span>

    <div class="d-flex w-100 mt-1">
    <span
      class="back d-flex gap-1 marg cursor-pointer"
      [class.disabled]="!hasPrevious"
      (click)="navigatePrevious()"
      >
      <mat-icon>arrow_backward</mat-icon>
      {{'offer.previousOffer' |translate}}
    </span>

      <span class="back d-flex gap-1 marg ms-auto me-auto">
    {{currentIndex + 1}} / {{offers.length}}
  </span>

    <span
      class="back gap-1 marg cursor-pointer "
      [class.disabled]="!hasNext"
      (click)="navigateNext()"
      >
      {{'offer.nextOffer' |translate}}
      <mat-icon>arrow_forward</mat-icon>
    </span>
    </div>
    <div class="d-flex flex-row justify-content-between align-items-baseline">
      <span class="title">{{'offer.offerFromUserAndDate' | translate:{
        user: offer.creator.firstName + ' ' + offer.creator.lastName,
        company: offer.creator.company.name,
        date: offer.creationDate | date:('dateFormatShort' | translate)
      } }}</span>
      <ng-content></ng-content>
    </div>
    <div *ngIf="offer.status==OfferStatus.RETRACTED && difference() <= 24 && (offer.creator.id == (userId$|async))"
         class="offer-retracted-container w-100">
      <img src="assets/svg-icons/circle-actions-close.svg"
           alt="">
      <span class="big-text ">{{'offer.offerRetractedLong' |translate}}</span>
      <div></div>
      <span class=" small-text">{{'offer.offerRetractedLongSubtext' |translate : {
        hour: (timer$|async)
      } }}</span>
    </div>
    <div class="offer-short-view">
      <app-offer-overview [offers]="[offer]" [(selectedOffer)]="offer" [proposalId]="proposalTile.id"
                          [insuredAmount]="proposalTile.insuredAmount"></app-offer-overview>

    </div>
    <div class="d-flex w-100 h-100 flex-column" style="overflow: hidden">
      <div class="d-flex align-items-center gap-2">
        <span class="open-all-label">
          {{(!allExpandState ? 'createOffer.openDetails' : 'createOffer.closeDetails') | translate}}
        </span>
        <mat-slide-toggle [(ngModel)]="allExpandState"
                          (ngModelChange)="clickButton($event)"></mat-slide-toggle>
      </div>
      <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
        <mat-expansion-panel *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.data' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.name' | translate}}:</div>
            <div>{{offer.externalInsurer.name}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.streetAndNumber' | translate}}:</div>
            <div>{{offer.externalInsurer.streetName}} {{offer.externalInsurer.houseNumber}}
            </div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.postalCodeAndLocation' | translate}}:</div>
            <div>{{offer.externalInsurer.postalCode}} {{offer.externalInsurer.location}}</div>
          </div>

          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:
            </div>
            <div>{{offer.externalInsurer.countryCode}},
              {{'countryCodes.' + offer.externalInsurer.countryCode |translate }}</div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="offer.offerType !== OfferType.EXTERNAL_COVERAGE" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.data' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.name' | translate}}:</div>
            <div>{{offer.creator.company.name}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.streetAndNumber' | translate}}:</div>
            <div>{{offer.creator.company.street}} {{offer.creator.company.houseNumber}}
            </div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.postalCodeAndLocation' | translate}}:</div>
            <div>{{offer.creator.company.postalCode}} {{offer.creator.company.location}}</div>
          </div>

          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:
            </div>
            <div>{{offer.creator.company.countryCode}},
              {{'countryCodes.' + offer.creator.company.countryCode |translate }}</div>
          </div>
        </mat-expansion-panel>
        <hr>
        <mat-expansion-panel *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.contactPerson' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.name' | translate}}:</div>
            <div>{{offer.creator.lastName}}, {{offer.creator.firstName}}</div>
          </div>
          <div class="d-flex proposal-details-row" *ngIf="offer.creator.phoneNumber">
            <div class="info-col">{{'offer.phoneNumber' | translate}}:</div>
            <div>{{offer.creator.phoneNumber}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.mobile' | translate}}:</div>
            <div>{{offer.creator.mobileNumber}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.email' | translate}}:</div>
            <div>{{offer.creator.email}}</div>
          </div>

        </mat-expansion-panel>
        <hr>
        <mat-expansion-panel [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.managementBusiness' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.role' | translate}}:</div>
            <div>{{(offer.isLeading ? 'offer.leadInsurer' : 'offer.followingInsurer') | translate}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.share' | translate}} ({{'offer.inPercent' | translate}}):</div>
            <div>{{offer.amountCovered |percent: '1.2-2'}}
            </div>
          </div>
        </mat-expansion-panel>
        <hr *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE">
        <mat-expansion-panel [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.premium' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.createOffer.referenceValue' | translate}}:</div>
            <div
              *ngIf="offer.referenceValue">{{ 'proposalDetails.createOfferTab.referenceValues.' + offer.referenceValue | translate }}</div>
          </div>
          <div *ngIf="offer.premiumInPercent != 0" class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.inPercent' | translate}}:</div>
            <div>{{offer.premiumInPercent |percent: '1.2-2'}}</div>
          </div>
          <div *ngIf="offer.premiumPerThousand != 0" class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.perThousand' | translate}}:</div>
            <div>{{offer.premiumPerThousand |permilleFormat}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.premium' | translate}}:</div>
            <div>{{offer.premium |currency:offer.currency}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.expectedTotalPremium' | translate}}:</div>
            <div>{{offer.expectedTotalPremium |currency:offer.currency}} </div>
          </div>
          <div class="d-flex proposal-details-row" *ngIf="offer.advancePremium">
            <div class="info-col">{{'offer.advancePremium' | translate}}:</div>
            <div *ngIf="offer.advancePremium">{{offer.advancePremium |currency:offer.currency}}</div>
          </div>
          <div class="d-flex proposal-details-row" *ngIf="offer.minimumPremium">
            <div class="info-col">{{'offer.minimumPremium' | translate}}:</div>
            <div *ngIf="offer.minimumPremium">{{offer.minimumPremium |currency:offer.currency}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.createOfferTab.typeOfDeductible' | translate}}:</div>
            <div
              *ngIf="offer.typeOfDeductible">{{"proposalDetails.createOfferTab.typeOfDeductibleOptions." + offer.typeOfDeductible | translate }}</div>
          </div>
          <div *ngIf="offer.typeOfDeductible != QuestionOptions.typeOfDeductible[0]" class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.createOfferTab.deductibleAbsoluteAmount' | translate}}:</div>
            <div>{{offer.deductibleAbsoluteAmount |currency:offer.deductibleCurrency }}</div>
          </div>
        </mat-expansion-panel>
        <hr>

        <ng-container *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE">
          <mat-expansion-panel [disabled]="offer.standardTermsAndConditions.length == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.defaultTerms' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="pre-wrap">
              - {{offer.standardTermsAndConditions.join('\n - ')}}
            </div>
          </mat-expansion-panel>
          <hr>
          <mat-expansion-panel [disabled]="offer.individualTermsAndConditions == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.individualTerms' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="pre-wrap">{{offer.individualTermsAndConditions}}
            </div>
          </mat-expansion-panel>
          <hr>
          <mat-expansion-panel [disabled]="offer.standardClauses.length == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.defaultClauses' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="pre-wrap">
              - {{offer.standardClauses.join('\n - ')}}
            </div>
          </mat-expansion-panel>
          <hr *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE">
          <mat-expansion-panel [disabled]="offer.individualClauses == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.individualClauses' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="pre-wrap">{{offer.individualClauses}}
            </div>
          </mat-expansion-panel>
          <hr class="line">
          <mat-expansion-panel [disabled]="offer.otherInformation == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.createOffer.individualInformationSection.otherInformation' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="pre-wrap">{{offer.otherInformation}}
            </div>
          </mat-expansion-panel>
        </ng-container>
        <hr>
        <mat-expansion-panel [disabled]="offer.attachedFiles.length === 0" [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.files' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-download-files [attachedFiles]="offer.attachedFiles">
          </app-download-files>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

  </ng-container>
</div>
